const REGISTER_POPUP = 'comex/Popup/REGISTER_POPUP'
const DESTROY_POPUP = 'comex/Popup/DESTROY_POPUP'

const SHOW_POPUP = 'comex/Popup/SHOW_POPUP'
const HIDE_POPUP = 'comex/Popup/HIDE_POPUP'

export const registerPopup = popup => ({
  type: REGISTER_POPUP,
  meta: { popup },
})

export const destroyPopup = popup => ({
  type: DESTROY_POPUP,
  meta: { popup },
})

export const showPopup = popup => ({
  type: SHOW_POPUP,
  meta: { popup },
  payload: { visible: true },
})

export const hidePopup = popup => ({
  type: HIDE_POPUP,
  meta: { popup },
  payload: { visible: false },
})

const defaultPopup = {
  visible: false,
}

const popup = (state = defaultPopup, { type, payload } = {}) => {
  switch (type) {
    case REGISTER_POPUP:
    case SHOW_POPUP:
    case HIDE_POPUP:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultReducer = {}

const reducer = (state = defaultReducer, { type, meta, payload } = {}) => {
  switch (type) {
    case REGISTER_POPUP:
    case SHOW_POPUP:
    case HIDE_POPUP:
      return {
        ...state,
        [meta.popup]: popup(state[meta.popup], { type, payload }),
      }

    case DESTROY_POPUP: {
      const { [meta.popup]: toDestroy, ...newState } = state
      return { ...newState }
    }

    default:
      return state
  }
}

export default reducer
